const setupAnalytics = () => {
  // Analytics setup is now handled by Pendo only
};

const setAnalyticsUser = (user, team) => {
  if (window.pendo && user?.id) {
    window.pendo.initialize({
      visitor: {
        id: user.id,
        full_name: user.name,
        email: user.email,
      },
      account: {
        id: team.id,
        name: team.name,
        chatbotEnabled: user.chatbotEnabled,
      },
    });
  }
};

const logEvent = (type, props = {}) => {
  // Event tracking with Pendo
  if (window.pendo && window.pendo.track) {
    window.pendo.track(type, props);
  }
};

export default logEvent;

export { setupAnalytics, setAnalyticsUser, logEvent };
